import { render } from "./LicenceAcceptanceScreen.vue?vue&type=template&id=3610383c&scoped=true"
import script from "./LicenceAcceptanceScreen.vue?vue&type=script&lang=js"
export * from "./LicenceAcceptanceScreen.vue?vue&type=script&lang=js"

import "./installer-page.scss?vue&type=style&index=0&id=3610383c&lang=scss&scoped=true"

import exportComponent from "/var/www/html/installer/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3610383c"]])

export default __exports__